import Vue from 'vue'
import ApiService from './ApiService'

export const BusinessLogicService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  get() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/business-logic`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  post(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/business-logic`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const ProductsService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  getAll() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/products`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const UserService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  query (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  get (slug) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/users/${slug}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/users/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (slug) {
    return ApiService.delete(`${this.baseURL}/users/${slug}`)
  },

  clonePermissions (from, to) {
    return new Promise((resolve, reject) => {
      let data = { 'destination_user_id': to.id }
      ApiService.post(`${this.baseURL}/users/${from.id}/clone-permissions`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  storeProfile (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/users/${slug}/profile`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  block (slug) {
    return ApiService.post(`${this.baseURL}/users/${slug}/block`)
  },

  unblock (slug) {
    return ApiService.post(`${this.baseURL}/users/${slug}/unblock`)
  },

  csmInfo () {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/users/csm`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  getCheckupScreenUserConfig() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/users/checkup-screen-config`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateCheckupScreenUserConfig(params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/users/checkup-screen-config`, {data: params})
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getByEntity(entityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/entities/${entityId}/users`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const ClusterService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  query (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/clusters`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/clusters`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/clusters/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  leave (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/clusters/${resource}/leave`)
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  },

  delete (resource) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/clusters/${resource}`)
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  }
}

export const RoleService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  getRoles (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/roles`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/roles`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/roles/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateSubRoles (resource, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/roles/${resource}/subroles`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (resource, params = {}) {
    return ApiService.delete(`${this.baseURL}/roles/${resource}`, params)
  },

  getInfoTypes (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/info-types`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getRolesByEntity (entityId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities/${entityId}/user-roles`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const ProfileService = {

  baseURL: process.env.VUE_APP_AUTH_URL,
  secondaryURL: process.env.VUE_APP_LEADS_URL,

  get: function (slug) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.secondaryURL}/users/${slug}/profile`)
        .then((response) => resolve(response.data.data))
        .catch((errors) => reject(errors))
    })
  },

  update: function (data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/auth/me`, data)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  updatePassword (data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/auth/changepassword`, data)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}

export const EntityService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  getEntitiesByAudProvider(audProviderId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/entities/byAudProvider/${audProviderId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  getRanuEntities () {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/entities/ranu-entities`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  get: function (slug) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/entities/${slug}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  store: function (params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v2/entities`, params)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  update: function (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/entities/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  updateIcon: function (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/v2/entities/${slug}/icon`, params,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  getProviders: function (slug, activity) {
    return new Promise((resolve, reject) => {
      const url = activity ? `${this.baseURL}/entities/${slug}/providers?activity=${activity}` : `${this.baseURL}/entities/${slug}/providers`
      ApiService.get(url)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  getBusinessPlans () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/business-plans`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getUsers (entityId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/users`, { entity: entityId })
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getOpsSatsData() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/entities/dashboard-op-info`)
       .then(response => resolve(response.data.data))
       .catch(errors => reject(errors))
    })
  },

  getCheckupEntityMeasurementGroups(entityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/entities/${entityId}/checkup-measurement-groups`)
        .then(res => resolve(res.data.data))
        .catch(err => reject(err))
    })
  },

  updateEntityCheckupMeasurementGroups(entityId, groupsIds) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/entities/${entityId}/checkup-measurement-groups`, { groupsIds })
        .then(res => resolve(res.data.data))
        .catch(err => reject(err))
    })
  }
}

export const FacilityService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  getAll (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/facilities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getFacilitiesByEntity (slug) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/entities/${slug}/facilities`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/facilities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/facilities/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  delete (slug, params = {}) {
    return ApiService.delete(`${this.baseURL}/facilities/${slug}`, params)
  }
}

export const FacilityScheduleService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  getByFacilitys (token, params = { facilities: "172" }) {
    let config = {
      headers: { 'Authorization': `${token}` },
      params
    }

    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/facility-schedules`, config)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/facility-schedules/`, params)
        .then(({data: { data , errors}}) => data ? resolve(data) : reject(errors))
        .catch(err => reject(err))
    })
  }
}

export const ZonesService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  getPortugueseDistricts (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/distritos`, {})
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getPortugueseCouncils (districtId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/distritos/${districtId}`, {})
        .then(response => resolve(response.data.data.concelhos))
        .catch(errors => reject(errors))
    })
  },

  getPortugueseParishes (councilId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/concelhos/${councilId}`, {})
        .then(response => resolve(response.data.data.freguesias))
        .catch(errors => reject(errors))
    })
  }
}

export const ActivityService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  query (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/activities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getActivityUsersByEntity (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities-activities-users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getWorkActivities (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities-activities-users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getActivitiesAgendaOptions() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/activities/activities-agenda-options`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}

export const EntityActivityUserService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  getOwnEntityActivityUserRecords (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/auth/entities-activities-users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/entities-activities-users`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/entities-activities-users/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  delete (slug, params = {}) {
    return ApiService.delete(`${this.baseURL}/entities-activities-users/${slug}`, params)
  }
}

export const WorkActivityService = {

  baseURL: process.env.VUE_APP_AUTH_URL,

  query (entityId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities/${entityId}/workactivities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (entityId, params) {
    return ApiService.patch(`${this.baseURL}/entities/${entityId}/workactivities`, params)
  },
}

export const EntityResponsibleService = {

  baseURL: process.env.VUE_APP_AUTH_URL,
  secondaryURL: process.env.VUE_APP_LEADS_URL,

  getEntityResponsibles (entityId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities/${entityId}/responsibles`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getResponsibleOptions (entityId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities/${entityId}/responsible-options`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateResponsible (entityId, profileId, params = {}) {
    return ApiService.patch(`${this.baseURL}/entities/${entityId}/profiles/${profileId}`, params)
  },

  updateResponsibles (entityId, params = {}) {
    return ApiService.patch(`${this.baseURL}/v2/entities/${entityId}/profiles`, params)
  }
}

export const AttendandeAndVacationsService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  getAttendances(params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v2/auth/attendances`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  storeAttendance(params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v2/auth/attendances`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateAttendance(eventId, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/auth/attendances/${eventId}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  downloadPdf(date, allUsers) {
    return ApiService.blob(`${this.baseURL}/v2/auth/attendances/pdf?date=${date}&all=${allUsers}`)
  },

  getHolidays(year) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v2/auth/holidays`, { 'year': year })
      .then(response => resolve(response.data.data))
      .catch(errors => reject(errors))
    })
  },

  getVacations(start, end) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v2/auth/vacations`, { 'start': start, 'end': end })
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  patchVacations(data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/auth/vacations`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  handleApprovals(data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/auth/vacations/approvals`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const TwoFactorAuthService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  generateTwoFactorCodeAndSendEmail() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/auth/tfa/generatecode`)
        .then(response => resolve(response))
        .catch(error => reject(error.response.data ? error.response.data : error))
    })
  },

  validateTwoFactorCode(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v2/auth/tfa/validatecode`, data)
        .then(response => resolve(response))
        .catch(error => {
          reject(error.response.data ? error.response.data : error)
        })
    })
  }
}

export const AuthEvohealthService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  getEntityHealthGroups(entityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/evohealth/entity/${entityId}/health-groups`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateEntityHealthGroups(entityId, healthGroupsIds) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/evohealth/entity/${entityId}/health-groups`, { healthGroups: healthGroupsIds })
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateEvohealthLeadsPermissions(data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v2/evohealth/leads-permissions`,data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadsPermissions(entityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/evohealth/entity/${entityId}/leads-permissions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getUserLeadsPermissions() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/evohealth/user-leads-permissions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getAllowedLeadsUsers(entityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/evohealth/users-by-lead-permissions?entity=${entityId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}

export const AuthSifarmaService = {
  baseURL: process.env.VUE_APP_AUTH_URL,

  getSifarmaPermissionsDataByFacility(facilityId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v2/sifarma/perms?facility=${facilityId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  submitPermissions(facilityId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v2/sifarma/perms?facility=${facilityId}`, data)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }

}
